import React from "react";

export default function ListPrices() {
  return (
    <div>
      <p>Lista de Precios</p>
    </div>
  );
}
